module.exports = __webpack_public_path__ + "img/wide.7e0d448e.jpg";